'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isChatRichTemplateMessage = undefined;

var _messageTypes = require('../constants/messageTypes');

var _isType = require('./isType');

var isChatRichTemplateMessage = exports.isChatRichTemplateMessage = (0, _isType.isType)(_messageTypes.CHAT_RICH_TEMPLATE);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/pubnub-message/operators/isChatRichTemplateMessage.js
// module id = 539
// module chunks = 2 3